import styled from 'styled-components'

export const Container = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  table {
    padding: 5px;
    display: flex;
    flex-direction: column;

    div.accordion.ui.styled {
      width: 100%;
    }
  }

  div.ui.attached.message > div.content {
    margin: 0;
    padding: 0;
  }
`

export const ContainerTab = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
